import { CHANGE_LOCALE } from "Constants/actionTypes";
import type { AppLocaleCode } from "../state";

export const changeLocale = (locale: AppLocaleCode) => {
  localStorage.setItem("currentLanguage", locale);
  return {
    type: CHANGE_LOCALE,
    payload: locale
  };
};
